import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Users from './pages/Users';
import Issues from './pages/Issues';
import ReportedListings from './pages/ReportedListings';
import ReportedUsers from './pages/ReportedUsers';
import Ambassadors from './pages/Ambassadors';
import Admins from './pages/Admins';
import PromotionalBanners from './pages/PromotionalBanners';
import CouponRedemptions from './pages/CouponRedemptions';
import AppConfig from './pages/AppConfig';
import ActionsLayout from './components/actions/ActionsLayout';
import CampusLayout from './components/campus/CampusLayout';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import SupportChats from './pages/SupportChats';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    setIsAuthenticated(!!accessToken);
    setLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route
            path="/"
            element={isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/dashboard/*"
            element={isAuthenticated ? (
              <Dashboard onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/products/*"
            element={isAuthenticated ? (
              <Products onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/users/*"
            element={isAuthenticated ? (
              <Users onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/issues"
            element={isAuthenticated ? (
              <Issues onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/supportchats"
            element={isAuthenticated ? (
              <SupportChats onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/reported-listings"
            element={isAuthenticated ? (
              <ReportedListings onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/reported-users"
            element={isAuthenticated ? (
              <ReportedUsers onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/ambassadors"
            element={isAuthenticated ? (
              <Ambassadors onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/admins"
            element={isAuthenticated ? (
              <Admins onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/promotional-banners"
            element={isAuthenticated ? (
              <PromotionalBanners onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/coupon-redemptions"
            element={isAuthenticated ? (
              <CouponRedemptions onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/app-config"
            element={isAuthenticated ? (
              <AppConfig onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/actions/*"
            element={isAuthenticated ? (
              <ActionsLayout onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
          <Route
            path="/campus/*"
            element={isAuthenticated ? (
              <CampusLayout onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )}
          />
        </Routes>
      </Router>
    </React.StrictMode>
  );
};
export default App;
